import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import { VersionGate } from './version/VersionGate'

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <VersionGate>
      <App />
    </VersionGate>
  </StrictMode>,
)
